/**
 * Mount Sunny attribution v2 — 2026-09-08.
 * Supplemental, consent-aware first/last-non-direct context only.
 * Shopify Google & YouTube owns purchase and standard ecommerce events.
 * No raw URLs, click IDs, browsing histories or health-interest profiles stored.
 */
(function () {
  'use strict';
  if (window.MountSunnyAttribution && window.MountSunnyAttribution.version === 2) return;
  var KEY = 'ms_attr_v2';
  var TTL = 90 * 24 * 60 * 60 * 1000;
  var LABEL = 'Marketing source (observed)';
  var state = null;
  var timer = null;
  var pending = null;
  var dirty = false;
  var initialized = false;
  var lastAtc = { key: '', time: 0 };
  var lastBooking = 0;

  function privacyAllowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!(p && p.analyticsProcessingAllowed() && p.marketingAllowed());
    } catch (_) { return false; }
  }
  function clean(value, length) {
    return String(value || '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, length || 80);
  }
  function parse(raw) {
    try { return JSON.parse(raw); } catch (_) { return null; }
  }
  function removeStorage(key) {
    try { localStorage.removeItem(key); } catch (_) {}
  }
  function save() {
    if (!state || !privacyAllowed()) return;
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (_) {}
  }
  function touch(source, medium, campaign, campaignId, timestamp) {
    return { source: clean(source, 40), medium: clean(medium, 30),
      campaign: clean(campaign, 80), campaignId: /^\d{1,20}$/.test(campaignId || '') ? campaignId : '',
      time: timestamp || Date.now() };
  }
  function lastParam(params, key) {
    var values = params.getAll(key).filter(function (v) { return v.trim(); });
    return values.length ? values[values.length - 1] : '';
  }
  function currentTouch() {
    var p = new URLSearchParams(location.search);
    var source = lastParam(p, 'utm_source').toLowerCase();
    var medium = lastParam(p, 'utm_medium').toLowerCase();
    var campaign = lastParam(p, 'utm_campaign');
    var campaignId = lastParam(p, 'gad_campaignid');
    var googleClick = ['gclid', 'gbraid', 'wbraid'].some(function (key) { return !!lastParam(p, key); });
    if (googleClick || (/^\d+$/.test(campaignId) && source === 'google')) {
      if (campaign === 'sag_organic') campaign = '';
      return touch('google', 'cpc', campaign, campaignId);
    }
    if (source || medium || campaign) {
      return touch(source || '(not set)', medium || '(not set)', campaign, '');
    }
    var host = '';
    try { host = new URL(document.referrer).hostname.toLowerCase().replace(/^www\./, ''); } catch (_) {}
    var own = location.hostname.toLowerCase().replace(/^www\./, '');
    if (host === own || host === 'mount-sunny.myshopify.com' || host.endsWith('.' + own)) return null;
    if (!host) return touch('direct', 'none', '', '');
    if (/^(mail\.google\.com|outlook\.(com|live\.com)|mail\.yahoo\.com)$/.test(host))
      return touch(host, 'email', '', '');
    if (/(^|\.)google\.[a-z.]+$/.test(host)) return touch('google', 'organic', '', '');
    if (/(^|\.)bing\.com$/.test(host)) return touch('bing', 'organic', '', '');
    if (/(^|\.)duckduckgo\.com$/.test(host)) return touch('duckduckgo', 'organic', '', '');
    if (/(^|\.)search\.yahoo\.com$/.test(host)) return touch('yahoo', 'organic', '', '');
    if (/(^|\.)ecosia\.org$/.test(host)) return touch('ecosia', 'organic', '', '');
    var socials = ['instagram.com', 'facebook.com', 'pinterest.com', 'tiktok.com'];
    for (var i = 0; i < socials.length; i++) {
      if (host === socials[i] || host.endsWith('.' + socials[i]))
        return touch(socials[i].split('.')[0], 'social', '', '');
    }
    return touch(host, 'referral', '', '');
  }
  function validTouch(value) {
    if (!value || !value.source || !Number.isFinite(value.time) || Date.now() - value.time >= TTL || value.time > Date.now()) return null;
    return touch(value.source, value.medium, value.campaign, value.campaignId, value.time);
  }
  function load() {
    var raw;
    try { raw = parse(localStorage.getItem(KEY)); } catch (_) {}
    if (!raw || raw.v !== 2) return { v: 2, first: null, last: null };
    return { v: 2, first: validTouch(raw.first), last: validTouch(raw.last) };
  }
  function describe(t) {
    if (!t) return 'Unknown';
    if (t.source === 'google' && t.medium === 'cpc') return 'Google Ads' + (t.campaign ? ' · ' + t.campaign : '');
    if (t.source === 'google' && (t.medium === 'product_sync' || t.campaign === 'sag_organic')) return 'Google free listings';
    if (t.source === 'direct') return 'Direct / unknown';
    return t.source + ' / ' + t.medium + (t.campaign ? ' · ' + t.campaign : '');
  }
  function summary() {
    if (!state || !privacyAllowed()) return '';
    var first = describe(state.first);
    var last = describe(state.last);
    return clean(first === last ? first : 'First: ' + first + ' | Latest non-direct: ' + last, 250);
  }
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function debugCart(cart) {
    if (new URLSearchParams(location.search).get('ms_debug') !== 'true') return;
    var attrs = (cart && cart.attributes) || {};
    console.info('Mount Sunny attribution QA', JSON.stringify({ version: 2,
      consentAllowed: privacyAllowed(), summary: attrs[LABEL] || '',
      legacyFieldsPresent: !!(attrs.ms_order_story_source || attrs.ms_attribution_json) }));
  }
  function syncCartAttributes() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (pending) { dirty = true; return pending; }
    dirty = false;
    var root = cartRoot();
    pending = fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart read'); return r.json(); })
      .then(function (cart) {
        var attrs = cart.attributes || {};
        // Send only owned keys: never overwrite customer notes or another app's attributes.
        var patch = {};
        ['ms_order_story_source', 'ms_attribution_json'].forEach(function (key) {
          if (attrs[key]) patch[key] = '';
        });
        var desired = cart.item_count > 0 ? summary() : '';
        if ((attrs[LABEL] || '') !== desired) patch[LABEL] = desired;
        if (!Object.keys(patch).length) { debugCart(cart); return; }
        return fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: patch }) })
          .then(function (r) { if (!r.ok) throw new Error('cart update'); return r.json(); })
          .then(debugCart);
      })
      .catch(function () { /* Tracking must never interrupt cart or checkout. */ })
      .finally(function () {
        pending = null;
        if (dirty) { dirty = false; return syncCartAttributes(); }
      });
    return pending;
  }
  function scheduleSync() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(syncCartAttributes, 200);
  }
  function emit(name, payload) {
    if (!privacyAllowed()) return;
    // One delivery path; no reserved acquisition fields or duplicate dataLayer aliases.
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    } catch (_) { /* A blocked or failing tag must not interrupt cart synchronization. */ }
  }
  function recordAdd(data, method) {
    if (!privacyAllowed()) { scheduleSync(); return; }
    var items = data && data.items ? data.items : [data];
    var key = items.map(function (item) {
      return item ? String(item.variant_id || item.id || '') + ':' + String(item.quantity || 1) : '';
    }).join('|');
    var ts = Date.now();
    if (!key || (lastAtc.key === key && ts - lastAtc.time < 1000)) return;
    lastAtc = { key: key, time: ts };
    emit('ms_add_to_cart', { cart_add_method: method, attribution_version: '2' });
    scheduleSync();
  }
  function start() {
    // Remove obsolete profiles instead of migrating untrustworthy or sensitive history.
    removeStorage('ms_attr_v1');
    try { sessionStorage.removeItem('ms_attr_sess_init'); } catch (_) {}
    if (!privacyAllowed()) {
      state = null;
      initialized = false;
      removeStorage(KEY);
      scheduleSync();
      return;
    }
    if (!initialized) {
      state = load();
      var snap = currentTouch();
      if (!snap && !state.first) snap = touch('direct', 'none', '', '');
      if (!state.first) state.first = snap;
      if (snap && (snap.source !== 'direct' || !state.last)) state.last = snap;
      initialized = true;
      save();
    }
    scheduleSync();
  }
  document.addEventListener('visitorConsentCollected', start);
  document.body.addEventListener('shapes:modalcart:afteradditem', function (event) {
    var data = event.detail && event.detail.response;
    if (data) recordAdd(data, 'ajax_modal');
  });
  // Non-modal Ajax carts: record only a successful response, never an attempted form submission.
  if (!(window.theme && window.theme.settings && window.theme.settings.cart_type === 'modal') && typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : input && input.url;
      var isAdd = false;
      try { var u = new URL(url, location.origin); isAdd = u.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(u.pathname); } catch (_) {}
      return originalFetch.apply(this, arguments).then(function (response) {
        if (isAdd && response.ok) response.clone().json().then(function (data) {
          if (data && !data.status) recordAdd(data, 'fetch');
        }).catch(function () {});
        return response;
      });
    };
  }
  document.addEventListener('click', function (event) {
    var a = event.target && event.target.closest && event.target.closest('a[href]');
    if (!a) return;
    var u;
    try { u = new URL(a.getAttribute('href'), location.origin); } catch (_) { return; }
    if (/(^|\.)janeapp\.com$|(^|\.)jane\.app$/.test(u.hostname) && Date.now() - lastBooking > 1000) {
      lastBooking = Date.now();
      // Destination category only: no treatment path, patient data or booking-completion claim.
      emit('ms_jane_booking_click', { booking_destination: 'jane', attribution_version: '2' });
    }
  }, true);
  window.MountSunnyAttribution = {
    version: 2,
    getState: function () { return privacyAllowed() && state ? JSON.parse(JSON.stringify(state)) : null; },
    flushCartAttributes: syncCartAttributes,
    getOrderSummary: summary
  };
  if (window.Shopify && window.Shopify.customerPrivacy) start();
  else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { start(); });
  } else start();
})();
